export enum Role {
  SuperAdmin = 'SUPER_ADMIN',
  CompanyAdmin = 'COMPANY_ADMIN',
  ProjectAdmin = 'PROJECT_ADMIN',
  User = 'USER',
}
